export const UltragrimCreds = () => (
  <p>
    Artwork & Layout by{' '}
    <a href="http://ultragrim.tumblr.com" target="_blank" rel="noreferrer">
      Ultragrim
    </a>
  </p>
);
